// Vendor #23: document upload checklist shown on vendor onboarding.
// `mandatory` follows the bug-tracker note: items 1,2,3,5,6,7,24,25,28 are required.

export type VendorDocItem = {
    doc_type: string;
    doc_name: string;
    mandatory: boolean;
};

export const VENDOR_DOCUMENT_CHECKLIST: VendorDocItem[] = [
    { doc_type: "company_registration", doc_name: "Company Registration Certificate", mandatory: true },
    { doc_type: "gst_registration", doc_name: "GST Registration Certificate", mandatory: true },
    { doc_type: "pan_card", doc_name: "PAN Card", mandatory: true },
    { doc_type: "iec", doc_name: "Import/Export Code (IM/EX)", mandatory: false },
    { doc_type: "msme_certificate", doc_name: "MSME Certificate (if applicable)", mandatory: true },
    { doc_type: "udyam_registration", doc_name: "Udyam Registration Certificate (for MSMEs)", mandatory: true },
    { doc_type: "iso_certifications", doc_name: "ISO Certifications (ISO 9001, ISO 14001, etc.)", mandatory: true },
    { doc_type: "quality_certification", doc_name: "Quality Certification (IFT, BIS, etc.)", mandatory: false },
    { doc_type: "approvals", doc_name: "Approvals (PSU, Govt. bodies, if any)", mandatory: false },
    { doc_type: "environmental_clearance", doc_name: "Environmental Clearance (if applicable)", mandatory: false },
    { doc_type: "factory_layout_plan", doc_name: "Factory Layout Plan", mandatory: false },
    { doc_type: "rent_agreement", doc_name: "Rent Agreement (if applicable)", mandatory: false },
    { doc_type: "phone_bill", doc_name: "Phone / Telephone Bill", mandatory: false },
    { doc_type: "electricity_bill", doc_name: "Electricity Bill", mandatory: false },
    { doc_type: "fire_safety_certificate", doc_name: "Fire Safety Certificate", mandatory: false },
    { doc_type: "list_of_machinery", doc_name: "List of Machinery (with specifications)", mandatory: false },
    { doc_type: "list_of_qc_equipment", doc_name: "List of Quality Control Equipment", mandatory: false },
    { doc_type: "calibration_certificates", doc_name: "Calibration Certificates for Equipment", mandatory: false },
    { doc_type: "list_of_staff", doc_name: "List of Staff (Permanent / Contractors)", mandatory: false },
    { doc_type: "epf_registration", doc_name: "Employee Provident Fund (EPF) Registration", mandatory: false },
    { doc_type: "health_safety_policy", doc_name: "Health and Safety Policy", mandatory: false },
    { doc_type: "material_inspection_report", doc_name: "Inward/Outward Material Quality Inspection Report", mandatory: false },
    { doc_type: "quality_assurance_manual", doc_name: "Quality Assurance Manual", mandatory: false },
    { doc_type: "performance_certificates", doc_name: "Performance Certificates (from clients, if any)", mandatory: true },
    { doc_type: "itr", doc_name: "ITR (Income Tax Returns) (Last 3 Years)", mandatory: true },
    { doc_type: "audited_balance_sheets", doc_name: "Audited Balance Sheets (Last 3 Years)", mandatory: false },
    { doc_type: "profit_loss_statement", doc_name: "Profit & Loss Statement (Last 3 Years)", mandatory: false },
    { doc_type: "cancelled_cheque", doc_name: "Cancelled Cheque", mandatory: true },
];
